module.exports = ".radioButtons input {\n  text-align: left;\n  display: inline;\n}\n\ninput {\n  /*background-color: #2e2e46;*/\n}\n\ninput.range {\n  width: 100%;\n}\n\ninput.range:focus {\n  padding: 0;\n}\n\nspan.failed {\n  overflow: auto;\n  max-height: 400px;\n  display: block;\n  text-align: left;\n}\n\nselect {\n  color: #000;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/achelos-iot/modals/move-profiles/move-profiles-modal.component.css
// module id = ./src/app/achelos-iot/modals/move-profiles/move-profiles-modal.component.css
// module chunks = main